import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui';

import type { PreviewEmailModalBodyProps } from '../../../../types';
import { PreviewEmailContentBox } from '../PreviewEmailContentBox';
import { PreviewEmailPetitionTitle } from '../PreviewEmailPetitionTitle';
import { PreviewEmailSenderInfo } from '../PreviewEmailSenderInfo';

type PreviewEmailModalBodyPropsReskin = Omit<PreviewEmailModalBodyProps, 'onClose'>;

export function PreviewEmailModalBody({
	emailTitle,
	emailContent,
	petitionTitle,
	userName,
	imageDataUrl,
}: PreviewEmailModalBodyPropsReskin): JSX.Element {
	return (
		<div className="bordered p-4 md:p-6">
			<div className="flex flex-col">
				<div>
					<Text as="h2" className="font-(family-name:Helvetica-Neue) mb-4 mt-0 font-normal" variant="heading">
						{emailTitle}
					</Text>
				</div>
				<PreviewEmailSenderInfo userName={userName} />
				<PreviewEmailPetitionTitle title={petitionTitle} userName={userName} />
				<PreviewEmailContentBox subject={emailTitle} body={emailContent} imageDataUrl={imageDataUrl} />
			</div>
		</div>
	);
}
